/**
 * Registry of per-product "Documentation" sections: converted-from-PDF
 * spec sheets, colour posters, and similar reference material rendered as
 * HTML/images on the product detail page (never embedded PDFs, never
 * download-only links -- see product-content.tsx, the "Documentation"
 * section).
 *
 * Add a product by dropping a component in this directory (see
 * avery-sw900.tsx for the pattern: hand-transcribed data sheet content in
 * a collapsed accordion, plus any poster/diagram images wired by a
 * scripts/supplier-assets/wire-product-docs.ts-style upload script) and
 * keying it here by product slug.
 */
import type { ComponentType } from 'react'

import { M3Wrap2080Docs } from './3m-2080'
import { PwfColourSeriesDocs } from './3m-pwf-colour-series'
import { ScotchgardPro200GlossDocs, ScotchgardPro200MatteDocs } from './3m-scotchgard-ppf-pro-series-200'
import { AveryPrismaproDocs } from './avery-prismapro'
import { AverySw900Docs } from './avery-sw900'
import { HexisBodyfencexGlossDocs, HexisBodyfencexmUltraMatteDocs, HexisBodyfencexsSatinDocs } from './hexis-bodyfence'

export const PRODUCT_DOCS_REGISTRY: Record<string, ComponentType> = {
  'avery-sw900': AverySw900Docs,
  'avery-prismapro': AveryPrismaproDocs,
  '3m-2080': M3Wrap2080Docs,
  '3m-pwf-colour-series': PwfColourSeriesDocs,
  'hexis-bodyfencex-gloss': HexisBodyfencexGlossDocs,
  'hexis-bodyfencexs-satin': HexisBodyfencexsSatinDocs,
  'hexis-bodyfencexm-ultra-matte': HexisBodyfencexmUltraMatteDocs,
  '3m-scotchgard-ppf-pro-series-200-gloss': ScotchgardPro200GlossDocs,
  '3m-scotchgard-ppf-pro-series-200-matte': ScotchgardPro200MatteDocs
}

export function getProductDocsComponent(slug: string | undefined | null): ComponentType | undefined {
  if (!slug) return undefined
  return PRODUCT_DOCS_REGISTRY[slug]
}
